import React, { useState } from 'react';
import { Modal } from '../../components/Modal';
import { ModalFooter } from '../../components/ModalFooter';
import { useCreateCustodian } from '../../hooks/useCustodians';

interface Props {
  projectId: string;
  projectName: string;
  existingNames: string[];
  onClose: () => void;
}

export function NewCustodianModal({ projectId, projectName, existingNames, onClose }: Props) {
  const [name, setName] = useState('');
  const [dirty, setDirty] = useState(false);
  const create = useCreateCustodian(projectId);

  const trimmed = name.trim();
  const isDuplicate = existingNames.some(n => n.toLowerCase() === trimmed.toLowerCase());

  const nameError =
    dirty && !trimmed ? 'Name is required' :
    dirty && name.length > 255 ? 'Name must be less than 255 characters' :
    dirty && isDuplicate ? 'A custodian with this name already exists' :
    undefined;

  const saveDisabled = !trimmed || isDuplicate;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setDirty(true);
    if (!trimmed || name.length > 255 || isDuplicate) return;
    create.mutate(name, { onSuccess: onClose });
  };

  return (
    <Modal
      title="Add Custodian"
      icon="fas fa-hdd"
      onClose={onClose}
      onSubmit={handleSubmit}
      footer={
        <ModalFooter
          onClose={onClose}
          nextLabel="Save"
          nextDisabled={saveDisabled}
          saving={create.isPending}
          savingLabel="Saving..."
        />
      }
    >
      <div className="form-group">
        <h4>Project: <small><i className="fas fa-gavel" aria-hidden="true" /> {projectName}</small></h4>
      </div>
      <div className={`form-group${nameError ? ' has-error' : ''}`}>
        {nameError && <span className="help-block">{nameError}</span>}
        <input
          type="text"
          placeholder="Custodian Name"
          className="form-control"
          value={name}
          onChange={e => { setName(e.target.value); setDirty(true); }}
          maxLength={255}
          disabled={create.isPending}
          autoFocus
        />
      </div>
    </Modal>
  );
}
